import $ from 'jquery';

const slickSection = $('.customers');
const slickOptionsFullWidth = {
  infinite: true,
  slidesToScroll: 1,
  arrows: false,
  centerMode: true,
  centerPadding: '0px',
  autoplay: true,
  variableWidth: true,
  autoplaySpeed: 0,
  speed: 2000,
  cssEase: 'linear',
};
$.each(slickSection, function () {
  let slickWrapper = $(this).find('.logos-slider__wrap');
  if (slickWrapper.children().length > 3) {
    slickWrapper.slick(slickOptionsFullWidth);
  }
});
